<ng-container appRoadDrawer *ngIf="breadcrumbs">
    <ng-container *ngFor="let breadcrumb of breadcrumbs; index as i">
        <ng-container *ngIf="i < breadcrumbs.length">
            <span class="breadcrumb-link" *ngIf="i > 0">-</span>
            <span [title]="breadcrumb['title']">
                <ng-container *ngTemplateOutlet="linkbreadcrumb; context: {breadcrumb, index: i}"></ng-container>
            </span>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #showbreadcrumb let-breadcrumb="breadcrumb">
    <span>
        {{ breadcrumb['title'] }}
    </span>
</ng-template>

<ng-template #linkbreadcrumb let-breadcrumb="breadcrumb" let-index="index">
    <a class="breadcrumb-link"
    [routerLink]="['/' + breadcrumb.link]"
    [ngClass]="{
    'inactive-text inactive-link': (index + 1) === breadcrumbs.length}"
    >
        <ng-container *ngTemplateOutlet="showbreadcrumb; context: {breadcrumb}"></ng-container>
    </a>
</ng-template>
